<script>
    import { onMount } from "svelte";
    import BackArrow from "../../../Components/Common/BackArrow.svelte";

    export let updatePhase = () => {};

    onMount(() => {
        const topElement = document.getElementById(
            "termsAndConditionsTopElement"
        );

        if (topElement)
            topElement.scrollIntoView({ behavior: "instant", block: "start" });
    });
</script>

<div
    class="flex w-full gap-x-4 items-center justify-start"
    id="termsAndConditionsTopElement"
>
    <BackArrow backFunc={() => updatePhase(5)} />
    <p class="text-[32px] font-bold text-primary">Complete Your Profile</p>
</div>

<p class="text-[20px] font-bold w-full">TCI Health Terms of Use</p>

<div
    class="rounded-lg flex flex-col gap-y-4 text-[16px] bg-gray-200 rounded-lg p-4"
>
    <p class="text-[20px] font-bold w-full">INTRODUCTION</p>

    <p>
        This website (referred to in these user terms as the Website) and the
        Anaemate application (Application) are owned and operated by TCI Health
        Pty Ltd ABN 18 656 230 278 (“TCI Health”), who is referred to in these
        Terms of Use as “we”, “us”, "our" and similar grammatical forms. “You”,
        “your” and other similar grammatical forms refers to any person who may
        use the Website or the Application from time to time.
    </p>

    <p>The material on the Website is copyright © 2022 TCI Health.</p>

    <p>
        TCI Health offers secure cloud-based services (Services) that allow the
        safe collection, storage and disclosure of individuals' personal
        information (which includes health information) in order to:
    </p>

    <ul class="pl-6 list-disc">
        <li>
            Streamline and automate the billing of patients for medical
            practitioners, including by facilitating payment of billings by
            third party payers (such as Medicare Australia, private health
            funds, or other regulatory payers);
        </li>

        <li>
            Provide its patient users a secure platform to pay any gap fees
            incurred from medical services provided by their practitioners; and
        </li>

        <li>
            Provide its users with statistical analysis of their invoices,
            billings and practices, including with respect to their individual
            patients.
        </li>
    </ul>

    <p>
        Clients and Patients may use the Website and the Anaemate application
        (Platforms) in accordance with these Terms of Use.
    </p>

    <p>For the purposes of these Terms of Use, the following meanings apply:</p>

    <p>
        'Clients' means any person or entity who engages us to provide them with
        Services.
    </p>

    <p>
        'GST' has the same meaning as defined in the A New Tax System (Goods and
        Services Tax) Act 1999 (Cth).
    </p>

    <p>
        'Patients' means any patient of a Client who has received, or is
        considering or planning to receive, medical services from a Client and
        whose information may be stored on TCI Health's servers.
    </p>

    <p>'Services' has the meaning set out above.</p>

    <p>
        'Services Fee' means the fees paid by the Clients to us in consideration
        for our provision of the Services, as advertised and notified on our
        Platforms from time to time.
    </p>

    <p>The Platforms are available for Clients and Patients to:</p>

    <ul class="pl-6 list-[lower-alpha]">
        <li>
            Access and use, conditional on your acceptance without alteration of
            the terms and conditions set out below. By continuing to access
            and/or use the Platforms, you are agreeing to these Terms of Use;
            and
        </li>

        <li>
            Upload material or information conditional on your acceptance
            without alteration of the terms and conditions set out below. By
            continuing to provide upload material or information to the
            Platforms you are agreeing to these Terms of Use.
        </li>
    </ul>

    <p>
        When you accept the Terms of Use on behalf of an employer, end user, or
        institution, you represent and warrant that you are authorised to do so
        by such entity by which you are employed or retained and for whose
        benefit you are using the Services. References herein to "you" and
        "your" shall mean "you and/or your employer, end user and your
        institution."
    </p>

    <p>
        In the interpretation of these Terms of Use, the following provisions
        apply unless the context otherwise requires:
    </p>

    <ol class="pl-6 list-decimal">
        <li>the singular includes the plural and vice versa;</li>

        <li>
            a reference to any legislation includes any statutory modification
            or re-enactment of, and any subordinate legislation issued under,
            that legislation or legislative provision;
        </li>

        <li>
            a reference to an individual or person includes a corporation,
            partnership, joint venture, association, authority, trust, state or
            government and vice versa;
        </li>

        <li>a reference to any gender includes all genders;</li>

        <li>
            a reference to a recital, clause, schedule, annexure or exhibit is
            to a recital, clause, schedule, annexure or exhibit of or to the
            Terms of Use;
        </li>

        <li>
            a reference to any party to the Terms of Use or any other document
            or arrangement includes that party's executors, administrators,
            substitutes, successors, and permitted assigns;
        </li>

        <li>
            a reference to dollars or \$ means the lawful currency of Australia;
        </li>

        <li>
            where an expression is defined, another part of speech or
            grammatical form of that expression has a corresponding meaning; and
            headings are for ease of reference only and do not affect
            interpretation;
        </li>

        <li>
            a rule of construction does not apply to the disadvantage of a party
            because the party was responsible for the preparation of the Terms
            of Use, or any part of it; and
        </li>

        <li>
            unless expressly stated to be otherwise, the meaning of general
            words is not limited by specific examples introduced by “including”,
            “for example” or similar inclusive expressions.
        </li>
    </ol>

    <!-- Part A -->
    <div class="flex flex-col gap-y-4 text-[16px]">
        <p>
            PART A: General terms of access to and use of the Platforms (Terms
            of Access) applicable to both Clients and Patients
        </p>
        <ol class="pl-6 list-decimal">
            <li>
                Use of the Platforms

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        Subject to PART B below, you may not use the Platforms
                        (or the material contained on it) for any illegal
                        purpose. This includes:
                    </li>
                    <ol class="pl-6 list-[lower-roman]">
                        <li>
                            the reproduction of the material in any material
                            form;
                        </li>
                        <li>
                            the distribution of the material in any material
                            form;
                        </li>
                        <li>
                            re-transmission of the material by any medium of
                            communication;
                        </li>
                        <li>
                            uploading or reposting the material to any other
                            site on the internet; and
                        </li>
                        <li>
                            “framing” the material on the Platforms with other
                            material on any other website.
                        </li>
                    </ol>

                    <p>
                        The above are unlawful in any jurisdiction and are
                        specifically prohibited by these Terms of Access.
                    </p>

                    <li>
                        Despite the above restrictions on use of the material on
                        the Platforms, and subject to your continued compliance
                        with these Terms of Use (and in consideration of your
                        payment of our fees), we grant you a limited
                        non-exclusive, non-transferable, non-sublicenceable,
                        revocable right to access and use the Services
                        (including access to certain content available on the
                        Platforms (“Content”)) solely in accordance with the
                        terms set out in the Terms of Use.
                    </li>

                    <li>
                        You may download material from the Platforms for your
                        use provided you do not remove any copyright and
                        trademark notices contained on the material.
                    </li>

                    <li>
                        You may not modify or copy:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>the layout of the Platforms; or</li>
                            <li>
                                any computer software and code contained in the
                                Platforms.
                            </li>
                        </ol>
                    </li>

                    <li>
                        You may only use the Services in accordance with the
                        Terms of Use, any directions given by us (acting
                        reasonably), and with all local and foreign laws and
                        regulations applicable to you, and for lawful purposes.
                    </li>

                    <li>
                        You must not, nor cause or permit any other person to:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                use the Services in a manner or for a purpose
                                which is improper, immoral or fraudulent, which
                                infringes any person’s rights (including
                                intellectual property rights or privacy rights),
                                violates these Terms of Use, or which restricts
                                or interferes with the provision of the Services
                                by us to any other user;
                            </li>

                            <li>
                                alter, modify, adapt or copy the whole or any
                                part of the Services;
                            </li>

                            <li>
                                reproduce, duplicate, sell, exploit, decompile,
                                dissemble, reverse engineer, enhance, alter or
                                otherwise interfere with the whole or any part
                                of the Services;
                            </li>

                            <li>
                                remove or obscure any copyright, trademark or
                                other proprietary notice on the Services;
                            </li>

                            <li>
                                enter into any transaction relating to access or
                                use of the Services with a party other than us,
                                without our prior written consent;
                            </li>

                            <li>
                                use any part of the Services or the Platforms to
                                aid any person or entity that conducts business
                                which is the same or substantially similar to
                                our business (being the business of providing
                                billing and administrative services to medical
                                practitioners);
                            </li>

                            <li>
                                attempt to disable or circumvent any security or
                                other technological measure designed to protect
                                the Services or users;
                            </li>

                            <li>
                                attempt to gain unauthorised access to the
                                Services, computer systems or networks connected
                                to the Services, through hacking, password
                                mining or any other means; or
                            </li>

                            <li>
                                use the Services for any purpose or activity of
                                an illegal, fraudulent, obscene, offensive,
                                personally offensive or defamatory nature or use
                                any mechanism, device, software or script to
                                affect the proper functioning of the Services.
                            </li>
                        </ol>
                    </li>

                    <li>
                        At all times you must:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                be honest and faithful in all your dealings;
                            </li>

                            <li>
                                not engage in any unsound, unethical or improper
                                business;
                            </li>

                            <li>
                                provide full and correct information to us, and
                                provide truthful explanations to us, in all
                                matters relating to the Terms of Use;
                            </li>

                            <li>
                                ensure at all times that your conduct does not
                                bring any discredit on us or cause any nuisance
                                or disruption to us or our employers;
                            </li>

                            <li>
                                immediately notify us if you become aware of any
                                malfunction of the Service or any breach of the
                                Terms of Use.
                            </li>
                        </ol>
                    </li>
                </ul>
            </li>

            <li>
                Registration

                <ol class="pl-6 list-[lower-alpha]">
                    <li>
                        In order for us to provide certain functions of the
                        Services, you must complete your registration details as
                        described on the Services and agree to these Terms of
                        Use.
                    </li>

                    <li>
                        At the time of registration, you must nominate an email
                        address and password.
                    </li>

                    <li>
                        You agree to:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                keep your password confidential and not disclose
                                it to any other person;
                            </li>

                            <li>
                                ensure that your registration details are true
                                and correct at all times and must notify us of
                                any change to your registration details as
                                originally supplied; and
                            </li>

                            <li>
                                immediately notify us of any unauthorised use of
                                your account or of password or any other breach
                                of security.
                            </li>
                        </ol>
                    </li>

                    <li>
                        You are solely responsible for selecting and providing
                        access to authorised users under your account and for
                        any use of the Services by your account (even by
                        unauthorised users).
                    </li>

                    <li>
                        You will select, supervise, monitor, and train the
                        authorised users who use the Services to ensure the
                        proper use of the Services, compliance with the Terms of
                        Use, and the security of the information maintained in
                        the Services.
                    </li>

                    <li>
                        You acknowledge and agree that we are not responsible
                        for the selection, supervision, monitoring, or training
                        of your authorised users. You are responsible for
                        terminating access to the Services for individuals who
                        are no longer authorised to use the Services in
                        connection with your account.
                    </li>
                </ol>
            </li>

            <li>
                Links to other websites

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        The Platforms contain links to sites on the internet
                        owned and operated by third parties and which are not
                        under our control.
                    </li>

                    <li>
                        In relation to the other sites on the internet, which
                        are linked on the Platforms, we:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                provide the links to other sites as a
                                convenience to you and the existence of a link
                                to other sites does not imply any endorsement by
                                us of the contents of the linked site; and
                            </li>

                            <li>
                                are not responsible for the material contained
                                on those linked sites.
                            </li>
                        </ol>
                    </li>
                </ul>
            </li>

            <li>
                Tax

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        Unless otherwise provided in the Terms of Use or in a
                        separate agreement executed by you and us, the Services
                        Fee and other fees we charge do not include any taxes or
                        duties (including, without limitation, sales, use,
                        value-added, and withholding taxes and duties) and
                        related fees, and you are responsible for paying all
                        taxes, duties, and related fees arising from your
                        purchases hereunder, excluding taxes based on our net
                        income, employees, or property. If we have the legal
                        obligation to pay or collect taxes, duties, or related
                        fees for which you are responsible, the appropriate
                        amount of such taxes, duties, and related fees shall be
                        invoiced to and paid by you, unless you provide a valid
                        tax exemption certificate authorised by the appropriate
                        taxing authority.
                    </li>

                    <li>
                        If you are in Australia, all consideration provided for
                        any taxable goods or services supplied under the Terms
                        of Use is exclusive of GST unless the contrary is
                        expressly stated by us in writing. You will be
                        responsible for paying any and all GST. The amount of
                        that consideration must be increased by an additional
                        amount equal to the GST on that taxable supply. The
                        party who has to pay the additional amount must pay it
                        at the same time as the consideration in respect of that
                        taxable supply that becomes due.
                    </li>

                    <li>
                        If GST is imposed on any supply made under these Terms
                        of Use and the consideration payable or to be provided
                        for the supply under any other clause in this Agreement
                        is not expressed to be inclusive of GST, the recipient
                        must pay to the supplier an amount on account of GST in
                        addition to that GST exclusive consideration.
                    </li>

                    <li>
                        The additional amount on account of GST referred to in
                        clause 4(c) above:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                is equal to the value of the GST exclusive
                                consideration payable or to be provided for the
                                relevant supply (without deduction or set-off)
                                multiplied by the prevailing GST rate; and
                            </li>

                            <li>
                                must be paid by the recipient to the supplier
                                when the supplier issues a Tax Invoice to the
                                recipient.
                            </li>
                        </ol>
                    </li>

                    <li>
                        If at any time an adjustment is made or required to be
                        made between a party and the relevant taxing authority
                        on account of any amount paid as GST under these Terms
                        of Use:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>a corresponding adjustment must be made;</li>

                            <li>adjustment notes must be issued; and</li>

                            <li>
                                any payment must be made between you and us as
                                may be necessary to give effect to the
                                adjustment.
                            </li>
                        </ol>
                    </li>
                </ul>
            </li>

            <li>
                Disclaimers and limitations of liability

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        We are an agent in the relationship between you and
                        other users, and any information we make available to
                        you (including any Patient-submitted information) is
                        provided by third parties and does not originate from
                        us. We do not independently verify the information
                        provided by third parties, including information
                        provided by any Individual User, and pass on information
                        to you (including any details about the Patients) with
                        no representation or warranty regarding the accuracy,
                        truthfulness, usefulness, reliability or integrity of
                        any information that has not expressly originated from
                        us.
                    </li>

                    <li>
                        With respect to the information contained on the
                        Platforms or linked sites on the internet, we:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                are making the Platforms available without
                                assuming a duty of care to users; and
                            </li>

                            <li>
                                are not in the business of providing
                                professional advice,
                            </li>
                        </ol>

                        <p>
                            and therefore, to the fullest extent permitted by
                            law, we disclaim any and all warranties, guarantees
                            or representations (either express or implied)
                            about:
                        </p>

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                the accuracy, reliability, completeness,
                                usefulness, timeliness or otherwise of any
                                information contained or referred to on the
                                Platforms or of any linked sites; and
                            </li>

                            <li>
                                the merchantability or fitness for any
                                particular purpose for any service or product of
                                any information contained or referred to on the
                                Platforms or on any linked sites.
                            </li>
                        </ol>
                    </li>

                    <li>
                        We will not be liable under any circumstances for any
                        loss of profits or any damages of any kind recognised by
                        law (even if it has been advised of the possibility of
                        such loss of profits or damages) which are the
                        consequence of you:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                acting, or failing to act, on any information
                                contained on or referred to on the Platforms or
                                any of the linked websites; and
                            </li>

                            <li>
                                using or acquiring, or your inability to use or
                                acquire, any service or product contained or
                                referred to on the Platforms or any linked
                                sites.
                            </li>
                        </ol>
                    </li>

                    <li>
                        We do not warrant, guarantee or make any representation
                        that:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                the Platforms, or the server that makes the
                                Platforms available on the internet are free of
                                software viruses;
                            </li>

                            <li>
                                the functions contained in any software
                                contained on the Platforms will operate
                                uninterrupted or are error- free; and
                            </li>

                            <li>
                                errors and defects in the Platforms will be
                                corrected,
                            </li>
                        </ol>

                        <p>
                            and you must make your own precautions to ensure
                            that the process which you use for accessing the
                            Platforms does not expose you to the risk of
                            viruses, malicious computer code or other forms of
                            interference which may damage your own computer
                            system.
                        </p>
                    </li>

                    <li>
                        We are not liable to you for:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                errors or omissions in the Platforms, or linked
                                sites on the internet;
                            </li>

                            <li>
                                delays to, interruptions of or cessation of the
                                services provided in the Platforms or linked
                                sites;
                            </li>

                            <li>
                                any interference or damage to your own computer
                                system which arises in connection with your use
                                of the Services, the Platforms, or linked sites;
                                and
                            </li>

                            <li>
                                defamatory, offensive or illegal conduct of any
                                user of the Platforms,
                            </li>
                        </ol>

                        <p>
                            whether caused through our negligence or the
                            negligence of our employees, independent contractors
                            or agents, or through any other cause.
                        </p>
                    </li>

                    <li>
                        You agree to accept the full cost of any necessary
                        repair, correction and maintenance of any of your
                        computer software or hardware, which may be necessary as
                        a consequence of you accessing the Platforms.
                    </li>

                    <li>
                        Where the Content provided by others contains opinions
                        or judgements of third parties, we do not purport to
                        endorse those opinions or judgements, nor the accuracy
                        or reliability of them.
                    </li>

                    <li>
                        You are responsible for all activities that occur under
                        your account on the Services, and you are liable for the
                        acts, defaults, and omissions of any person who accesses
                        your account on the Services, as if they were acts,
                        defaults, or omissions by you.
                    </li>

                    <li>
                        Whilst we will undertake reasonable efforts to protect
                        the information which we transmit and receive in
                        accordance with our Privacy Policy, we do not warrant
                        the security of any information which you transmit to
                        us, and you are responsible for ensuring you have
                        retained appropriate backups of any Content which you
                        may provide to us.
                    </li>

                    <li>
                        Our sole liability for breach of any terms, conditions
                        and warranties in jurisdictions where such terms,
                        conditions and warranties are implied and required by
                        law, where the breach relates to the supply of services
                        that are not of a kind ordinarily acquired for personal,
                        domestic or household use or consumption, and where it
                        is fair and reasonable to do so, is limited at our
                        option to one or more of the following:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>the supplying of the Services again; or</li>

                            <li>
                                the payment of the cost of having the Services
                                supplied again.
                            </li>
                        </ol>
                    </li>

                    <li>
                        To the fullest extent permitted by law and except as
                        otherwise expressly stated in these Terms of Use, our
                        liability to you for any reason (including any breach
                        of, or omission under, these Terms of Use) is limited in
                        aggregate to the amount of the Service Fee paid to us by
                        you in respect of that calendar month.
                    </li>

                    <li>
                        To the fullest extent permitted by law we are not liable
                        for any direct, indirect, incidental, special and/or
                        consequential damage, loss, claim, expense or loss of
                        profits, economic loss, business interruption, loss of
                        goodwill, loss of profits, loss of savings on overheads
                        or any loss of data which result from any use or access,
                        or any inability to use or access, or misuse by you or
                        any other party, of the Services or otherwise in
                        connection with any content, even if we have been
                        advised of the possibility of such damages or loss.
                    </li>

                    <li>
                        Nothing in these Terms of Use is intended to exclude or
                        limit any condition, warranty, right, or liability in a
                        manner that is not permissible under applicable law. In
                        some circumstances, some jurisdictions may not permit
                        the exclusion of certain warranties or conditions, the
                        exclusion of incidental or consequential damages, or the
                        limitation or exclusion of liability for loss or damage
                        caused by negligence, breach of contract, or breach of
                        implied terms. Accordingly, only the above limitations
                        which are lawful in the applicable jurisdiction in which
                        you may use the Services. With respect to any
                        limitations which are not lawful as stated, our
                        liability will be limited to the maximum extent
                        permitted by applicable law.
                    </li>

                    <li>
                        Subject to this clause 5 , our liability for loss or
                        damage to you will be reduced proportionately to the
                        extent that:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                such loss or damage has been caused by your
                                failure to comply with your obligations and
                                responsibilities under these Terms of Use; or
                            </li>

                            <li>
                                your actions or omissions have contributed to
                                such loss or damage
                            </li>
                        </ol>

                        <p>
                            regardless of whether a claim is made by the other
                            party.
                        </p>
                    </li>
                </ul>
            </li>

            <li>
                Termination of access

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        Your agreement with us commences on the date you
                        successfully register on the Platforms or commence using
                        our Services, and remains in force until terminated in
                        accordance with this Terms of Use or as otherwise
                        stipulated under any Purchase Order.
                    </li>

                    <li>
                        We will use reasonable efforts to make the Services
                        accessible 24 hours a day, seven days a week or as
                        otherwise stated on the Services from time to time, but
                        we do not guarantee such availability.
                    </li>

                    <li>
                        We reserve the right from time to time to immediately
                        alter, interrupt, suspend, or terminate your right to
                        access the whole or any part of the Services (including
                        your access to our Platforms) at any time in our sole
                        discretion and without giving any explanation,
                        justification or notice for the termination of access.
                    </li>

                    <li>
                        Without limiting our rights under clause 6(c) above, we
                        may also immediately terminate your right to access the
                        whole or any part of the Services (including your access
                        to our Platforms) without any notice to you if you are
                        in breach of these Terms of Use at any time.
                    </li>

                    <li>
                        On termination, you must immediately pay any and all
                        outstanding invoices or any charges or fees incurred as
                        a result of your access and use of the Service before
                        the date of termination.
                    </li>

                    <li>
                        You agree that we will not be liable for any costs,
                        losses or damages of any kind that may arise from any
                        such interruption, suspension, termination or alteration
                        pursuant to this clause.
                    </li>

                    <li>
                        Termination does not affect any accrued rights or
                        liabilities of either you or us, nor does it affect any
                        provision which is expressly or by implication intended
                        to operate after termination.
                    </li>
                </ul>
            </li>

            <li>
                Alteration of Terms of Access

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        We reserve the right to change these Terms of Access:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>with or without further notice to you; and</li>

                            <li>
                                without giving you any explanation or
                                justification for such change.
                            </li>
                        </ol>
                    </li>

                    <li>
                        Amendments will be effective immediately upon
                        notification on the Website. Your continued use of the
                        Website will represent an agreement by you to be bound
                        by the Terms of Use as amended.
                    </li>
                </ul>
            </li>

            <li>
                Use and disclosure of personal information

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        We and any people or legal entities authorised by us may
                        collect and process the personal information:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                which you may provide when accessing the
                                Platforms, such as your name, address, e-mail
                                address and other personal information about
                                you; and
                            </li>

                            <li>
                                regarding the way in which you use the Website
                                including, without limitation, information
                                acquired through the use of cookies delivered to
                                your computer when you access our Website.
                            </li>
                        </ol>
                    </li>

                    <li>
                        We may authorise others to offer you goods and services
                        using the information acquired, as described in clause
                        8(a) .
                    </li>

                    <li>
                        We will comply with the Australian privacy legislation
                        with respect to our collection, storage, use and
                        disclosure of your personal information. Please refer to
                        our full privacy policy here for details of how we
                        collect, store, use and disclose your personal
                        information.
                    </li>

                    <li>
                        You will at all times indemnify and keep indemnified us
                        and our respective officers, employees, contractors and
                        agents (Those Indemnified) from and against any loss
                        (including reasonable legal costs and expenses) or
                        liability incurred by any of Those Indemnified arising
                        from any claim, demand, suit, action or proceeding by
                        any person against any of Those Indemnified where such
                        loss or liability arose out of, in connection with or in
                        respect of:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                your use of the Services (including but not
                                limited to your access and use of the Platforms
                                and the Content);
                            </li>

                            <li>
                                any breach of these Terms of Use by you; and
                            </li>

                            <li>
                                our collection, use, publication or distribution
                                of the material or information supplied by you
                                from time to time.
                            </li>
                        </ol>
                    </li>
                </ul>
            </li>

            <li>
                Intellectual property rights

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        We reserve all intellectual property rights, including,
                        but not limited to, copyright in the Content, the
                        Platforms, and any material or services provided by it.
                        The Content is provided to you in accordance with the
                        licence set out under clause 1(b) above only and may not
                        be:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                re-sold or re-distributed in any material form;
                            </li>

                            <li>stored in any storage media; or</li>

                            <li>re-transmitted in any media,</li>
                        </ol>

                        <p>without our prior written consent.</p>
                    </li>

                    <li>
                        We reserve the right to modify, vary, correct, alter,
                        remove or delete any part or all of the Platforms or the
                        Content, at any time in our sole discretion and without
                        any notice to you. We and our respective officers,
                        employees and agents have no liability for any costs,
                        losses or damages of any kind, which you may incur,
                        arising whether directly or indirectly as a consequence
                        of removing any material or information from the
                        Platforms.
                    </li>

                    <li>
                        All logos, icons, brand names or service names that
                        identifying the owner and operator of the Platforms are
                        our copyright property or our trade marks or service
                        marks. All other trade marks or service marks on the
                        Platforms or any linked websites are the property of
                        their respective owners. You must obtain written
                        permission before reusing any copyrighted material that
                        is published on the Platforms. Any unauthorised use of
                        the materials appearing on the Platforms may violate
                        copyright, trade mark and other property rights or legal
                        protections and could result in criminal and/or civil
                        penalties.
                    </li>

                    <li>
                        Other than for the purposes of, and subject to the
                        conditions prescribed under applicable copyright laws
                        which apply in your location, and except as expressly
                        authorised by the Terms of Use, you may not in any form
                        or by any means without our prior written approval:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                adapt, reproduce, distribute, print, display,
                                perform, publish or create derivative works from
                                any part of the Services; or
                            </li>

                            <li>
                                commercialise any Content, goods or services
                                obtained from any part of the Services.
                            </li>
                        </ol>
                    </li>

                    <li>
                        You guarantee and warrant that you hold all intellectual
                        property rights in the Content which you upload to the
                        Platforms and/or have obtained any relevant consents
                        which may be required under applicable privacy
                        legislation for the use and disclosure of such
                        information (and you indemnify us from any damages,
                        costs, losses or liabilities which may arise from our
                        use of the Content). By submitting any information or
                        other material to us (including inputting data or
                        engaging in any other form of communication), you grant
                        to us a perpetual, royalty-free, non-exclusive,
                        irrevocable, unrestricted, worldwide licence to do the
                        following in respect of the information or material:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                for the purpose of complying with our
                                obligations under, and to permit you to comply
                                with all of your obligations under, the Terms of
                                Use;
                            </li>

                            <li>
                                use, copy, sublicence, redistribute, edit,
                                adapt, transmit, publish and/or broadcast,
                                publicly perform or display; and
                            </li>

                            <li>
                                sublicence to any third parties the unrestricted
                                right to exercise any of the rights granted in
                                paragraph (ii), provided that, where such use is
                                not for the purpose of complying with these
                                Terms of Use, all personal and sensitive
                                information will be removed from the information
                                and materials before such information and/or
                                materials is made available to any other person.
                            </li>
                        </ol>
                    </li>

                    <li>
                        The licence in the previous clause includes the right to
                        exploit all proprietary rights in that information or
                        other material including but not limited to rights under
                        copyright, trademark, service mark or patent laws under
                        any jurisdiction worldwide.
                    </li>

                    <li>
                        You unconditionally and irrevocably consent to all acts
                        and omissions by us, or people authorised by us, which
                        would otherwise amount to an infringement of your moral
                        rights in that information or other material. This
                        includes consent to change the information or other
                        material even if the change amounts to a “derogatory
                        treatment” of the information or other material as that
                        term is defined in Division 4 of Part 9 of the Copyright
                        Act 1968 (Cth).
                    </li>

                    <li>
                        At our request and expense, you will execute and deliver
                        to us such instruments and take such other actions as
                        may be required to give full legal effect to this grant
                        of licence and consent.
                    </li>

                    <li>
                        You are solely responsible for
                        retaining/maintaining/storing and backing up
                        (electronically and/or with hard copies) any information
                        or materials that you wish to preserve. We are not
                        responsible for unauthorised access to, use of or
                        alteration of your information.
                    </li>

                    <li>
                        To the extent any moral rights are not transferable or
                        assignable, you hereby waive and agree never to assert
                        any and all moral rights, or to support, maintain or
                        permit any action based on any moral rights that you may
                        have in or with respect to any information or materials
                        you upload to or through the Platforms. You expressly
                        release us and our agents, partners, licensees,
                        successors, and assigns from any and all claims,
                        demands, liabilities, or causes of action, whether now
                        known or unknown, for defamation, copyright
                        infringement, violation of moral rights, and invasion of
                        the rights to privacy, publicity, or personality or any
                        similar matter, or based upon or relating to your
                        posting of information or materials.
                    </li>
                </ul>
            </li>

            <li>
                Relevant jurisdiction

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        If any part of these Terms of Access is found to be
                        void, unlawful, or unenforceable then that part will be
                        deemed to be severable from the balance of these Terms
                        of Access and the severed part will not affect the
                        validity and enforceability of any remaining provisions.
                    </li>

                    <li>
                        These Terms of Access will be governed by and
                        interpreted in accordance with the law of Victoria,
                        without giving effect to any principles of conflicts of
                        laws.
                    </li>

                    <li>
                        You agree to the jurisdiction of the courts of Victoria
                        to determine any dispute arising out of these Terms of
                        Access.
                    </li>
                </ul>
            </li>
        </ol>
    </div>

    <!-- Part B -->
    <div class="flex flex-col gap-y-4 text-[16px]">
        <p>PART B: Additional terms of use for Clients (Terms of Use)</p>

        <ol class="pl-6 list-decimal">
            <li>
                Payment and Fees

                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        When you purchase the Services from us, you agree to the
                        following invoicing and payment terms set out in this
                        Part B of these Terms of Use.
                    </li>

                    <li>
                        By using our Services, you agree to pay the Services
                        Fees. You appoint us as your agent (and we accept such
                        appointment) to:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                issue invoices on your behalf and as instructed
                                by you in respect of the medical services in
                                relation to which you have requested we provide
                                the Services;
                            </li>

                            <li>
                                collect and deposit into our bank accounts the
                                payment of such invoices, which we will
                                beneficially hold on your behalf;
                            </li>

                            <li>
                                issue receipts in your name in respect of those
                                invoices;
                            </li>

                            <li>
                                disburse amounts collected from those invoices
                                to you, less our Services Fees, within a
                                reasonable time after receipt; and
                            </li>

                            <li>
                                issue you with a tax invoice for the Services
                                Fees plus GST for the period since the last tax
                                invoice.
                            </li>
                        </ol>
                    </li>

                    <li>
                        You agree to complete, sign and give to us all forms,
                        documents, or other approvals necessary for us to
                        provide you with the Services.
                    </li>

                    <li>
                        You agree that you are liable for (and indemnify us
                        against) any repayments, claims, losses, or other
                        damages which may arise as a result of monies received
                        under clause (b) above, including (but not limited to)
                        any liabilities, losses, costs or expenses which we may
                        incur in connection with any claims brought against us
                        by a regulator, tribunal or government department
                        (including under the Health Legislation Amendment
                        (Improved Medicare Compliance and Other Measures) Act
                        2018 (Cth).
                    </li>

                    <li>
                        We reserve the right to update, amend, add, remove or
                        replace available pricing plans, terminology, and
                        functionality in the TCI Health system.
                    </li>

                    <li>
                        If you fail to pay us any amount payable under the Terms
                        of Use when due, then:

                        <ol class="pl-6 list-[lower-roman]">
                            <li>
                                all money you owe us becomes immediately
                                payable;
                            </li>

                            <li>
                                we may suspend providing the Services to you,
                                and may charge a reactivation fee for the
                                suspended Services;
                            </li>

                            <li>
                                you must pay, in addition to the amount
                                outstanding, interest at the rate equal to the
                                cash rate target published by the Reserve Bank
                                of Australia, plus a margin of 5% per annum or
                                the highest amount permitted by applicable law
                                on the amount outstanding for each day during
                                which the default continues; and
                            </li>

                            <li id="termsOfConditionsLastItem">
                                you must pay all reasonable expenses incurred by
                                us in enforcing the Terms of Use, including, but
                                not limited to, all expenses of any legal
                                proceeding and all reasonable attorneys’ fees
                                incurred in connection with such action.
                            </li>
                        </ol>
                    </li>
                </ul>
            </li>
        </ol>
    </div>
</div>

<div class="flex items-center justify-between w-full">
    <p class="text-[20px] font-bold cursor-pointer text-secondary">
        Send to my email
    </p>

    <button class="btn btn-md btn-secondary" on:click={() => updatePhase(7)}>
        I agree
    </button>
</div>
